<div class="loadingOverlay" *ngIf="isLoading">
  <img src="assets/images/loadinganim.gif">
</div>
<div class="leagueHeader" *ngIf="showHeader" #leagueHeader>
  <div class="body">
    <div class="leagueName">
      <div class="icon" [ngStyle]="{'background-image':'url(\''+bucketURL+tierData.league.lg_abbr+'_icon.svg\')'}"></div><span>{{tierData.league.name}} | </span><span class="status">{{tierData.league.status}}</span>
    </div>
    <div class="leagueMenu">
      <a class="menuItem" [href]="baseURL+'/tournament/'+tierData.league.lg_abbr+'/'+tierData.tournament_code">League</a>
      <a class="menuItem active" [routerLink]="'/tiers/'+tierData.fantasy_lg_id">My Team</a>
      <a class="menuItem" [href]="baseURL+'/tournament/settings/'+tierData.league.lg_abbr+'/'+tierData.tournament_code">Settings</a>
    </div>
  </div>
</div>
<div class="tiersContainer">
  <div class="body">
    <div class="error" *ngIf="errorMsg != ''">{{errorMsg}}</div>
    <div class="success" *ngIf="successMsg != ''">{{successMsg}}</div>
    <div class="headers">
      <div class="header" [ngClass]="{'active':activeTab == 0}" (click)="activeTab = 0">{{ (mode == 'create')?'Players':'Standings' }}</div>
      <div class="header" [ngClass]="{'active':activeTab == 1}" (click)="activeTab = 1" [matBadgeHidden]="!isMobile || tiers[0].remaining == myTeam.length" [matBadge]="myTeam.length - tiers[0].remaining" matBadgeColor="warn">{{ teamName }}</div>
    </div>
    <div class="tabs" appSameHeight className="sameHeight">
      <div class="tab sameHeight" [ngClass]="{'active':activeTab == 0}" [ngStyle]="{'float':(isMobile)?'none':'left'}">
        <div class="body">
          <div *ngIf="mode == 'create'">
            <mat-tab-group class="tiers" *ngIf="tiers.length" [(selectedIndex)]="currentTier" #MatTabGroup>
              <mat-tab *ngFor="let tier of tiers" [label]="tier.label" (click)="changeTier(tier.value)">
                <ng-template matTabContent>
                  <div class="playersTable">
                    <div class="searchContainer">
                      <mat-form-field>
                        <input type="text" placeholder="Search..." matInput (keyup)="setSearch($event)">
                        <i class="fas fa-search" matSuffix></i>
                      </mat-form-field>
                    </div>
                    <div class="playersRemaining">Players Remaining: {{tier.remaining}}</div>
                    <div class="playersHeaders">
                      <div class="pHeader pHeaderWide">Name</div>
                      <div class="pHeader">Tier</div>
                      <div class="pHeader">Proj</div>
                      <div class="pHeader">Add</div>
                    </div>
                    <div class="playersBody" [ngClass]="{'activeDrafts':leagueHeader != null && leagueHeader.nativeElement.offsetParent.offsetTop >= 30}">
                      <div class="pRow" *ngFor="let player of players | callback: filterPlayers">
                        <div class="pValue pValueWide" [ngClass]="{'out':player.is_out=='Y'}" (click)="openInfo(player,player.id,$event)">{{player.fn + ' ' + player.ln}} 
                          <ng-container *ngIf="player.inj == 'Y'">
                            <div class="injuryBubble" tooltip="{{player?.it}}" [options]="tooltipPly">{{getInjuryAbbr(player?.it)}}
                            </div>
                          </ng-container>
                          <div class="outStatus" *ngIf="player.is_out == 'Y'">OUT</div>
                        </div>
                        <div class="pValue">{{player.tier}}</div>
                        <div class="pValue">{{player.prj | number: '1.2-2'}}</div>
                        <div class="pValue"><i class="fas fa-plus-circle pAdd" [ngClass]="{'out':player.is_out=='Y'}" *ngIf="player.is_hide == 0 && tiers[player.tier].remaining > 0" (click)="selectPlayer(player)"></i></div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
          <div *ngIf="mode != 'create'">
            <div class="playersTable">
              <div class="playersHeaders">
                <div class="pHeader pHeaderWide">Team Name</div>
                <div class="pHeader">Thru</div>
                <div class="pHeader">To Par</div>
                <div class="pHeader">Rank</div>
              </div>
              <div class="playersBody">
                <div class="pRow" *ngFor="let standing of standings">
                  <div class="pValue pValueWide"><a [routerLink]="'/tiers/'+standing.league_id+'/'+standing.lgm_id">{{standing.team_name}}</a></div>
                  <div class="pValue">{{standing.pmr}}</div>
                  <div class="pValue">{{standing.team_total}}</div>
                  <div class="pValue">{{standing.team_rank}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab sameHeight" [ngClass]="{'active':activeTab == 1}">
        <div class="body">
          <div class="selectSection">
            <mat-select placeholder="My Entries" (selectionChange)="changeTeam($event)">
              <mat-option value="0" *ngIf="tierData.max_entries > myTeams.length">New Entry</mat-option>
              <mat-option *ngFor="let team of myTeams" [value]="team.id">{{team.name}}</mat-option>
            </mat-select>
          </div>
          <div class="saveSection">
            <button mat-button class="joinBtn" *ngIf="isMyTeam && mode == 'create'" (click)="(parameters.lgm_id == 0)?joinLeaguePopup():sendRoster()" [ngClass]="{'disabled':!isMyTeam || mode != 'create' || tiers[0].remaining > 0}" [disabled]="!isMyTeam || mode != 'create' || tiers[0].remaining > 0">
              {{(parameters.lgm_id > 0)?'Update':'Join'}}
            </button>
          </div>
          <div class="teamTable" [ngClass]="{'activeDrafts':leagueHeader != null && leagueHeader.nativeElement.offsetParent.offsetTop >= 30}">
            <div class="playerRows">
              <div class="tRow" *ngFor="let player of myTeam" (click)="(isMobile && player.id==0 && isMyTeam && mode=='create')?activeTab = 0:null;">
                <div class="tierCol">
                  <div class="tierContainer" [ngClass]="'tier-'+player.pn">
                    <div class="tier">{{player.pn}}</div>
                    <div class="tierLabel">{{player.pts_text}}</div>
                  </div>
                </div>
                <!-- show player details -->
                <div class="headshotCol" *ngIf="player.id > 0">
                  <div class="headshot" [ngStyle]="{'background-image':'url(\''+player.plrImage+'\')'}"></div>
                </div>
                <div class="playerCol" *ngIf="player.id > 0" (click)="openInfo(player,player.id,$event)">
                  <div class="nameTop">
                    {{player.pname.split(' ')[0]}}
                  </div>
                  <div class="nameBottom">
                    {{getLastName(player)}}
                  </div>
                </div>
                <div class="statCol" *ngIf="player.id > 0">
                  <div class="statLabel">
                    {{mode == 'create'?'Proj':''}}
                  </div>
                  <div class="stat">
                    {{mode=='create'?(player.proj | number: '1.0-0'):''}}
                  </div>
                </div>
                <div class="deleteCol" *ngIf="player.id > 0 && isMyTeam && mode == 'create'" (click)="removePlayer(player,$event)">
                    <i class="fas fa-times"></i>
                </div>
                <!-- show FPTS here in standings mode -->
                <div class="statCol" *ngIf="player.id > 0 && mode != 'create'">
                  <div class="statLabel">
                    To Par
                  </div>
                  <div class="stat">
                    {{player.fpts}}
                  </div>
                </div>
                <!-- select player/hidden player-->
                <div class="selectCol" *ngIf="player.id == 0">
                  <div class="nameMiddle">
                    {{player.pname}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="hideContent" *ngIf="visibleQuickJoin && quickContests.length" (click)="visibleQuickJoin = false;quickContests = [];"></div>
<div class="quickjoin" [ngClass]="{'active':visibleQuickJoin && quickContests.length}">
  <div class="body">
    <h1>Stay in the Action!</h1>
    <h2>Check out these other contests with the same format!</h2>
    <div class="cardContainer">
      <div *ngFor="let contest of quickContests">
        <mat-card class="card" *ngIf="contest.joined_entrants < contest.entrants && contest.my_entries < contest.max_entries">
          <mat-card-title class="cardTitle">
            {{contest.name}}
          </mat-card-title>
          <mat-card-subtitle class="sub">
            <div class="entries" *ngIf="contest.confirm == 0">
              <span class="current" *ngIf="contest.league_id == parameters.league_id">Current Contest<br></span>
              Entries: {{contest.joined_entrants}}/{{contest.entrants}}<br>
              Your Entries: {{contest.my_entries}}/{{contest.max_entries}}
            </div>
            <div class="roster" *ngIf="contest.confirm == 1">
              <h1>Submit this roster?</h1>
              <div class="player" *ngFor="let player of myTeam">{{player.pname}}</div>
            </div>
          </mat-card-subtitle>
          <mat-card-actions class="actions">
            ENTER:<br *ngIf="isMobile">
            <button class="thisBtn" [ngClass]="{'warn':contest.league_id == parameters.league_id}" mat-button (click)="quickJoin(contest)">{{contest.confirm == 0?(contest.league_id == parameters.league_id?'Again':'This Lineup'):'Confirm?'}}</button>
            <button class="btn" mat-button (click)="redirect(contest)">New Lineup</button>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
  </div>
</div>